import React from "react";
import { Box } from "@mui/material";
import { getSourceIcon } from "../SourceModal.config";
import { SourceCode } from "../SourceModal.types";

interface SourceIconProps {
    code: SourceCode | string | undefined;
    size?: "small" | "medium" | "large" | number;
    alt?: string;
    className?: string;
    style?: React.CSSProperties;
}

const SIZE_MAP = {
    small: 24,
    medium: 32,
    large: 48,
};

const SourceIcon: React.FC<SourceIconProps> = ({
    code,
    size = "medium",
    alt,
    className,
    style,
}) => {
    const iconUrl = getSourceIcon(code);
    const pixelSize = typeof size === "number" ? size : SIZE_MAP[size];

    return (
        <Box
            component="img"
            src={iconUrl}
            alt={alt || `${code} icon`}
            className={className}
            sx={{
                width: pixelSize,
                height: pixelSize,
                objectFit: "contain",
                ...style,
            }}
            onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                e.currentTarget.src =
                    "/assets/images/typeImages/default-icon.png";
            }}
        />
    );
};

export default SourceIcon;
